import {
  GET_ALLBRANDTOUCHPOINT_REQUEST,
  GET_ALLBRANDTOUCHPOINT_SUCCESS,
  GET_HOME_TP_LIST_REQUEST,
  GET_HOME_TP_LIST_SUCCESS,
  GET_CLIENT_REQUEST,
  GET_CLIENT_SUCCESS,
  SET_CLIENT_FROM_HASH,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
} from "./actions";
import { initialState } from "./selectors";
import i18n from "../../i18n";

export default function client(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_CLIENT_REQUEST:
      return {
        ...state,
      };
    case GET_CLIENT_SUCCESS:
      if (payload && payload?.lang) {
        i18n.changeLanguage(payload?.lang);
      }
      return {
        ...state,
        client: payload,
      };
    case GET_USERS_REQUEST:
      return {
        ...state,
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: payload,
      };
    case GET_HOME_TP_LIST_REQUEST:
      return {
        ...state,
        homeTPLists: null,
      };
    case GET_ALLBRANDTOUCHPOINT_REQUEST:
      return {
        ...state,
        // allBrandTouchPoint: null
      };
    case GET_ALLBRANDTOUCHPOINT_SUCCESS:
      return {
        ...state,
        allBrandTouchPoint: payload,
      };
    case GET_HOME_TP_LIST_SUCCESS:
      return {
        ...state,
        homeTPLists: payload,
      };
    case SET_CLIENT_FROM_HASH:
      if (payload.lang) {
        i18n.changeLanguage(payload?.lang);
      }
      return {
        ...state,
        client: payload,
      };
    default:
      return state;
  }
}
